import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import { DatePickerModeEnum } from './date-picker.enum'
import {
  DatePickerCalendarFixed,
  DatePickerCalendarFixedProps,
} from './DatePickerCalendarFixed'
import { DatePickerCalendarFlexible } from './DatePickerCalendarFlexible'
import { useTravelTypeContext } from '../../contexts'
import { TravelTypeEnum } from '../../../lib/graphql'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../../shadcn/components/ui/tabs'

interface DatePickerCalendarProps
  extends Omit<
    DatePickerCalendarFixedProps,
    'allowMultiDates' | 'shouldDisplayHourPickers'
  > {
  mode: DatePickerModeEnum
  shouldDisplayHourPickers?: boolean
}

export const DatePickerCalendar: React.FC<DatePickerCalendarProps> = ({
  isMobile,
  field,
  onDatesSelected,
  closeModal,
  house,
  dateCalendarProps,
  control,
  nameHours,
  revampPicker,
  onValid,
  mode,
  shouldDisplayHourPickers,
}) => {
  const { travelType } = useTravelTypeContext()

  const defaultTabs = useMemo(
    () => (field?.value?.flexible ? 'flexible' : 'fixed'),
    [field?.value?.flexible],
  )
  const allowMultiDates = travelType !== TravelTypeEnum.CORPORATE_EVENING_EVENT

  const displayHourPickers = shouldDisplayHourPickers
    ? true
    : Boolean(
        travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT &&
          mode !== DatePickerModeEnum.HOUSE_SEARCH,
      )

  if (!revampPicker) {
    return (
      <DatePickerCalendarFixed
        field={field}
        control={control}
        dateCalendarProps={dateCalendarProps}
        closeModal={closeModal}
        onDatesSelected={onDatesSelected}
        shouldDisplayHourPickers={displayHourPickers}
        house={house}
        isMobile={isMobile}
        nameHours={nameHours}
      />
    )
  }

  return (
    <Tabs defaultValue={defaultTabs} className='w-full rounded-md'>
      <TabsList className='mb-5 grid w-full grid-cols-2'>
        <TabsTrigger value='fixed' className='rounded-sm'>
          <FormattedMessage
            id='ui.DatePickerCalendar.tabFixed'
            defaultMessage='Dates fixes'
          />
        </TabsTrigger>
        <TabsTrigger
          value='flexible'
          className='rounded-sm'
          data-testid='flexible-dates-btn'
        >
          <FormattedMessage
            id='ui.DatePickerCalendar.tabFlexible'
            defaultMessage='Dates flexibles'
          />
        </TabsTrigger>
      </TabsList>
      <TabsContent value='fixed'>
        <DatePickerCalendarFixed
          field={field}
          control={control}
          dateCalendarProps={dateCalendarProps}
          closeModal={closeModal}
          onDatesSelected={onDatesSelected}
          shouldDisplayHourPickers={displayHourPickers}
          house={house}
          isMobile={isMobile}
          nameHours={nameHours}
          revampPicker
          onValid={onValid}
        />
      </TabsContent>
      <TabsContent value='flexible'>
        <DatePickerCalendarFlexible
          field={field}
          onDatesSelected={onDatesSelected}
          closeModal={closeModal}
          allowMultiDates={allowMultiDates}
          onValid={onValid}
        />
      </TabsContent>
    </Tabs>
  )
}
